import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CenteredContainer from "./CenteredContainer";

export default function LoadingSpinner() {
  return (
    <CenteredContainer>
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    </CenteredContainer>
  );
}
